import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-links',
  templateUrl: './links.component.html',
  styleUrls: ['./links.component.css']
})
export class LinksComponent implements OnInit {

  constructor() {
  }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/links/links.component.ts